type TResolve<Z> = (value: Z | PromiseLike<Z>) => void;
type TReject = (reason: unknown) => void;

type PromiseWithResolvers<T> = {
    promise: Promise<T>;
    resolve: TResolve<T>;
    reject: TReject;
};

declare global {
    interface PromiseConstructor {
        withResolvers<T = unknown>(): PromiseWithResolvers<T>;
    }
}

export const withResolvers = <T = unknown>(): PromiseWithResolvers<T> => {
    let resolve: TResolve<T> = () => {};
    let reject: TReject = () => {};
    const promise = new Promise<T>((res: TResolve<T>, rej: TReject) => {
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        resolve,
        reject
    };
};

Promise.withResolvers ||= withResolvers;
